angular.module('app')
  .directive('slideDown', function ($timeout) {
    return {
      restrict: 'A',
      scope: { expanded: '=slideDown' },
      transclude: true,
      link: (scope, element, attrs) => {
        const elementScope = element.scope();
        const lazyRender = attrs.lazyRender !== undefined;
        const keepAlive = attrs.keepAlive !== undefined;
        const loaded = false;

        const {
          duration = 0.1,
          timingFunction = 'ease-in-out',
          emitOnClose,
          onClose,
        } = attrs;

        let closePromise = null;
        let openPromise = null;

        const getHeight = () => {
          let height = 0;
          const children = element.children();

          for (let i = 0; i < children.length; i += 1) {
            height += children[i].clientHeight;
          }

          return `${height}px`;
        };

        const show = () => {
          if (closePromise) {
            $timeout.cancel(closePromise);
          }

          if (lazyRender) {
            scope.lazyRender = true;
          }

          scope.loaded = true;

          return $timeout(() => {
            if (openPromise) {
              $timeout.cancel(openPromise);
            }

            element.css({
              overflowY: 'hidden',
              transitionProperty: 'height',
              transitionDuration: `${duration}s`,
              transitionTimingFunction: timingFunction,
              height: getHeight(),
            });

            openPromise = $timeout(() => element.css({
              overflowY: 'visible',
              transition: 'none',
              height: 'auto',
            }), duration * 1000);

            return openPromise;
          });
        };

        const hide = () => {
          if (openPromise) {
            $timeout.cancel(openPromise);
          }

          element.css({
            overflowY: 'hidden',
            transitionProperty: 'height',
            transitionDuration: `${duration}s`,
            transitionTimingFunction: timingFunction,
            height: '0px',
          });

          if (emitOnClose || onClose || lazyRender) {
            closePromise = $timeout(() => {
              if (emitOnClose) {
                scope.$emit(emitOnClose, {});
              }

              if (onClose) {
                elementScope.$eval(onClose);
              }

              if (lazyRender && !keepAlive) {
                scope.lazyRender = false;
              }

              if (loaded) {
                scope.loaded = false;
              }
            }, duration * 1000);

            return closePromise;
          }

          return null; // just to make eslint happy
        };

        return scope.$watch('expanded', (value) => {
          if (value) {
            return $timeout(show);
          }

          if (value != null) {
            element.css({ height: getHeight() });
          }

          return $timeout(hide);
        });
      },
      template: (element, attrs) =>
        // `<div><div ng-transclude ${attrs.lazyRender !== undefined ? 'ng-if="lazyRender"' : ''} ${attrs.keepAlive !== undefined ? 'ng-show="loaded"' : ''}></div></div>`,
        `<div ng-transclude ${attrs.lazyRender !== undefined ? 'ng-if="lazyRender"' : ''} ${attrs.keepAlive !== undefined ? 'ng-show="loaded"' : ''}></div>`,
    };
  });
